var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 365,
    height: 365,
    viewBox: "0 0 365 365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-Custom_Size_1);\n      }\n\n      .cls-2 {\n        fill: #1e505f;\n      }\n\n      .cls-3 {\n        fill: #b0b0e0;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 365,
    height: 365
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device_Desktop_Shape_Cloud_Style_Two",
    "data-name": "Device=Desktop, Shape=Cloud, Style=Two",
    transform: "translate(0 2.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7635",
    "data-name": "Path 7635",
    className: "cls-2",
    d: "M0,183.7a58.358,58.358,0,0,1,40.84-55.619,58.423,58.423,0,0,1,78.874-78.655,58.555,58.555,0,0,1,111.549,0,58.423,58.423,0,0,1,78.874,78.655,58.288,58.288,0,0,1,.023,111.238,58.423,58.423,0,0,1-78.874,78.655,58.555,58.555,0,0,1-111.549,0,58.423,58.423,0,0,1-78.874-78.655A58.348,58.348,0,0,1,0,183.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7636",
    "data-name": "Path 7636",
    className: "cls-3",
    d: "M363,176.189a58.17,58.17,0,0,0-40.607-55.457,58.171,58.171,0,0,0-78.425-78.425,58.172,58.172,0,0,0-110.913,0A58.171,58.171,0,0,0,54.63,120.732a58.167,58.167,0,0,0-.023,110.913,58.171,58.171,0,0,0,78.425,78.425,58.171,58.171,0,0,0,110.913,0,58.171,58.171,0,0,0,78.425-78.425A58.159,58.159,0,0,0,363,176.189Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7637",
    "data-name": "Path 7637",
    className: "cls-4",
    d: "M221.293,247.39a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,221.293,247.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7638",
    "data-name": "Path 7638",
    className: "cls-4",
    d: "M240.93,247.491a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,240.93,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7639",
    "data-name": "Path 7639",
    className: "cls-4",
    d: "M245.831,279.46a4.912,4.912,0,1,0-4.912,4.912A4.916,4.916,0,0,0,245.831,279.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7640",
    "data-name": "Path 7640",
    className: "cls-4",
    d: "M231.106,302.813a4.912,4.912,0,1,0-4.912-4.913A4.913,4.913,0,0,0,231.106,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7641",
    "data-name": "Path 7641",
    className: "cls-4",
    d: "M221.293,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,221.293,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7642",
    "data-name": "Path 7642",
    className: "cls-4",
    d: "M221.293,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,221.293,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7643",
    "data-name": "Path 7643",
    className: "cls-4",
    d: "M221.293,210.509a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,221.293,210.509Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7644",
    "data-name": "Path 7644",
    className: "cls-4",
    d: "M240.93,63a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,240.93,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7645",
    "data-name": "Path 7645",
    className: "cls-4",
    d: "M240.93,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,240.93,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7646",
    "data-name": "Path 7646",
    className: "cls-4",
    d: "M211.265,265.932a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,211.265,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7647",
    "data-name": "Path 7647",
    className: "cls-4",
    d: "M211.265,339.682a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,211.265,339.682Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7648",
    "data-name": "Path 7648",
    className: "cls-4",
    d: "M211.265,302.813a4.912,4.912,0,1,0-4.912-4.913A4.913,4.913,0,0,0,211.265,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7649",
    "data-name": "Path 7649",
    className: "cls-4",
    d: "M240.93,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,240.93,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7650",
    "data-name": "Path 7650",
    className: "cls-4",
    d: "M240.93,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,240.93,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7651",
    "data-name": "Path 7651",
    className: "cls-4",
    d: "M240.93,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,240.93,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7652",
    "data-name": "Path 7652",
    className: "cls-4",
    d: "M221.293,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,221.293,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7653",
    "data-name": "Path 7653",
    className: "cls-4",
    d: "M221.293,284.259a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,221.293,284.259Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7654",
    "data-name": "Path 7654",
    className: "cls-4",
    d: "M231.106,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,231.106,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7655",
    "data-name": "Path 7655",
    className: "cls-4",
    d: "M231.106,44.568a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,231.106,44.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7656",
    "data-name": "Path 7656",
    className: "cls-4",
    d: "M221.293,321.14a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,221.293,321.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7657",
    "data-name": "Path 7657",
    className: "cls-4",
    d: "M261.482,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,261.482,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7658",
    "data-name": "Path 7658",
    className: "cls-4",
    d: "M240.93,311.428a4.9,4.9,0,0,0-1.3,9.621,58.655,58.655,0,0,0,3.839-8.887A4.9,4.9,0,0,0,240.93,311.428Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7659",
    "data-name": "Path 7659",
    className: "cls-4",
    d: "M251.669,44.557a4.916,4.916,0,0,0,4.912-4.912,4.317,4.317,0,0,0-.113-1.016,57.839,57.839,0,0,0-9.2,3.139A4.886,4.886,0,0,0,251.669,44.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7660",
    "data-name": "Path 7660",
    className: "cls-4",
    d: "M231.106,192.182a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,231.106,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7661",
    "data-name": "Path 7661",
    className: "cls-4",
    d: "M231.106,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,231.106,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7662",
    "data-name": "Path 7662",
    className: "cls-4",
    d: "M231.106,265.932a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,231.106,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7663",
    "data-name": "Path 7663",
    className: "cls-4",
    d: "M231.106,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,231.106,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7664",
    "data-name": "Path 7664",
    className: "cls-4",
    d: "M221.293,26.128a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,221.293,26.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7665",
    "data-name": "Path 7665",
    className: "cls-4",
    d: "M221.293,63a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,221.293,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7666",
    "data-name": "Path 7666",
    className: "cls-4",
    d: "M160.326,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,160.326,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7667",
    "data-name": "Path 7667",
    className: "cls-4",
    d: "M261.482,63a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,261.482,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7668",
    "data-name": "Path 7668",
    className: "cls-4",
    d: "M200.515,126.935a4.912,4.912,0,1,0,4.912,4.912A4.916,4.916,0,0,0,200.515,126.935Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7669",
    "data-name": "Path 7669",
    className: "cls-4",
    d: "M200.515,53.185a4.912,4.912,0,1,0,4.912,4.912A4.916,4.916,0,0,0,200.515,53.185Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7670",
    "data-name": "Path 7670",
    className: "cls-4",
    d: "M211.265,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,211.265,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7671",
    "data-name": "Path 7671",
    className: "cls-4",
    d: "M200.515,90.065a4.912,4.912,0,1,0,4.912,4.912A4.916,4.916,0,0,0,200.515,90.065Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7672",
    "data-name": "Path 7672",
    className: "cls-4",
    d: "M200.515,200.8a4.912,4.912,0,1,0,4.912,4.912A4.916,4.916,0,0,0,200.515,200.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7673",
    "data-name": "Path 7673",
    className: "cls-4",
    d: "M200.515,274.548a4.912,4.912,0,1,0,4.912,4.912A4.916,4.916,0,0,0,200.515,274.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7674",
    "data-name": "Path 7674",
    className: "cls-4",
    d: "M200.515,237.679a4.912,4.912,0,1,0,4.912,4.912A4.916,4.916,0,0,0,200.515,237.679Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7675",
    "data-name": "Path 7675",
    className: "cls-4",
    d: "M185.8,2.877a4.89,4.89,0,0,0,9.757.4,58.732,58.732,0,0,0-7.227-.44C187.484,2.821,186.648,2.843,185.8,2.877Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7676",
    "data-name": "Path 7676",
    className: "cls-4",
    d: "M160.326,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,160.326,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7677",
    "data-name": "Path 7677",
    className: "cls-4",
    d: "M160.326,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,160.326,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7678",
    "data-name": "Path 7678",
    className: "cls-4",
    d: "M200.515,16.3a4.912,4.912,0,1,0,4.912,4.912A4.916,4.916,0,0,0,200.515,16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7679",
    "data-name": "Path 7679",
    className: "cls-4",
    d: "M160.326,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,160.326,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7680",
    "data-name": "Path 7680",
    className: "cls-4",
    d: "M200.515,321.241a4.912,4.912,0,1,0-4.912-4.912A4.916,4.916,0,0,0,200.515,321.241Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7681",
    "data-name": "Path 7681",
    className: "cls-4",
    d: "M160.326,284.372a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,160.326,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7682",
    "data-name": "Path 7682",
    className: "cls-4",
    d: "M160.326,247.491a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,160.326,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7683",
    "data-name": "Path 7683",
    className: "cls-4",
    d: "M200.515,163.815a4.912,4.912,0,1,0,4.912,4.913A4.916,4.916,0,0,0,200.515,163.815Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7684",
    "data-name": "Path 7684",
    className: "cls-4",
    d: "M211.265,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,211.265,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7685",
    "data-name": "Path 7685",
    className: "cls-4",
    d: "M190.7,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,190.7,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7686",
    "data-name": "Path 7686",
    className: "cls-4",
    d: "M211.265,7.688a2.339,2.339,0,0,0,.294-.034c-1.265-.553-2.552-1.05-3.862-1.513A4.9,4.9,0,0,0,211.265,7.688Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7687",
    "data-name": "Path 7687",
    className: "cls-4",
    d: "M211.265,44.568a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,211.265,44.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7688",
    "data-name": "Path 7688",
    className: "cls-4",
    d: "M211.265,192.182a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,211.265,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7689",
    "data-name": "Path 7689",
    className: "cls-4",
    d: "M211.265,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,211.265,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7690",
    "data-name": "Path 7690",
    className: "cls-4",
    d: "M211.265,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,211.265,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7691",
    "data-name": "Path 7691",
    className: "cls-4",
    d: "M190.7,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,190.7,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7692",
    "data-name": "Path 7692",
    className: "cls-4",
    d: "M190.7,302.813a4.912,4.912,0,1,0-4.912-4.913A4.913,4.913,0,0,0,190.7,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7693",
    "data-name": "Path 7693",
    className: "cls-4",
    d: "M190.7,265.932a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,190.7,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7694",
    "data-name": "Path 7694",
    className: "cls-4",
    d: "M190.7,192.182a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,190.7,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7695",
    "data-name": "Path 7695",
    className: "cls-4",
    d: "M190.7,44.568a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,190.7,44.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7696",
    "data-name": "Path 7696",
    className: "cls-4",
    d: "M190.7,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,190.7,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7697",
    "data-name": "Path 7697",
    className: "cls-4",
    d: "M190.7,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,190.7,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7698",
    "data-name": "Path 7698",
    className: "cls-4",
    d: "M231.106,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,231.106,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7699",
    "data-name": "Path 7699",
    className: "cls-4",
    d: "M292.8,265.932a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,292.8,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7700",
    "data-name": "Path 7700",
    className: "cls-4",
    d: "M313.348,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,313.348,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7701",
    "data-name": "Path 7701",
    className: "cls-4",
    d: "M323.161,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,323.161,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7702",
    "data-name": "Path 7702",
    className: "cls-4",
    d: "M323.161,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,323.161,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7703",
    "data-name": "Path 7703",
    className: "cls-4",
    d: "M292.8,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,292.8,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7704",
    "data-name": "Path 7704",
    className: "cls-4",
    d: "M323.161,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,323.161,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7705",
    "data-name": "Path 7705",
    className: "cls-4",
    d: "M323.161,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,323.161,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7706",
    "data-name": "Path 7706",
    className: "cls-4",
    d: "M292.8,302.813a4.912,4.912,0,1,0-4.912-4.913A4.913,4.913,0,0,0,292.8,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7707",
    "data-name": "Path 7707",
    className: "cls-4",
    d: "M292.8,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,292.8,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7708",
    "data-name": "Path 7708",
    className: "cls-4",
    d: "M302.609,247.491a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,302.609,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7709",
    "data-name": "Path 7709",
    className: "cls-4",
    d: "M302.609,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,302.609,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7710",
    "data-name": "Path 7710",
    className: "cls-4",
    d: "M302.609,284.372a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,302.609,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7711",
    "data-name": "Path 7711",
    className: "cls-4",
    d: "M292.8,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,292.8,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7712",
    "data-name": "Path 7712",
    className: "cls-4",
    d: "M292.8,192.182a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,292.8,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7713",
    "data-name": "Path 7713",
    className: "cls-4",
    d: "M292.8,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,292.8,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7714",
    "data-name": "Path 7714",
    className: "cls-4",
    d: "M349.562,150.287a4.9,4.9,0,0,0,8.311,3.534,58.828,58.828,0,0,0-4.517-8.3A4.894,4.894,0,0,0,349.562,150.287Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7715",
    "data-name": "Path 7715",
    className: "cls-4",
    d: "M343.724,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,343.724,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7716",
    "data-name": "Path 7716",
    className: "cls-4",
    d: "M333.911,192.182A4.913,4.913,0,1,0,329,187.27,4.912,4.912,0,0,0,333.911,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7717",
    "data-name": "Path 7717",
    className: "cls-4",
    d: "M333.911,155.2A4.912,4.912,0,1,0,329,150.287,4.912,4.912,0,0,0,333.911,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7718",
    "data-name": "Path 7718",
    className: "cls-4",
    d: "M302.609,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,302.609,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7719",
    "data-name": "Path 7719",
    className: "cls-4",
    d: "M362.684,173.335a58.519,58.519,0,0,0-1.231-8.616,4.88,4.88,0,0,0,1.231,8.616Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7720",
    "data-name": "Path 7720",
    className: "cls-4",
    d: "M73.183,297.9a4.912,4.912,0,0,0-9.824,0,4.863,4.863,0,0,0,.226,1.412c.44.474.881.937,1.344,1.4.644.644,1.31,1.276,1.976,1.886a4.867,4.867,0,0,0,1.355.215A4.926,4.926,0,0,0,73.183,297.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7721",
    "data-name": "Path 7721",
    className: "cls-4",
    d: "M313.348,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,313.348,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7722",
    "data-name": "Path 7722",
    className: "cls-4",
    d: "M354.474,192.182a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,354.474,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7723",
    "data-name": "Path 7723",
    className: "cls-4",
    d: "M343.724,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,343.724,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7724",
    "data-name": "Path 7724",
    className: "cls-4",
    d: "M313.348,265.932a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,313.348,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7725",
    "data-name": "Path 7725",
    className: "cls-4",
    d: "M313.348,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,313.348,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7726",
    "data-name": "Path 7726",
    className: "cls-4",
    d: "M313.348,192.182a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,313.348,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7727",
    "data-name": "Path 7727",
    className: "cls-4",
    d: "M343.724,136.747a4.921,4.921,0,0,0,2.112-.5,59.808,59.808,0,0,0-6.787-5.838,4.838,4.838,0,0,0,4.675,6.335Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7728",
    "data-name": "Path 7728",
    className: "cls-4",
    d: "M313.348,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,313.348,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7729",
    "data-name": "Path 7729",
    className: "cls-4",
    d: "M251.669,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,251.669,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7730",
    "data-name": "Path 7730",
    className: "cls-4",
    d: "M251.669,302.813a4.912,4.912,0,1,0-4.912-4.913A4.913,4.913,0,0,0,251.669,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7731",
    "data-name": "Path 7731",
    className: "cls-4",
    d: "M251.669,265.932a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,251.669,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7732",
    "data-name": "Path 7732",
    className: "cls-4",
    d: "M251.669,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,251.669,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7733",
    "data-name": "Path 7733",
    className: "cls-4",
    d: "M282.045,63a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,282.045,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7734",
    "data-name": "Path 7734",
    className: "cls-4",
    d: "M282.045,99.878a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,282.045,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7735",
    "data-name": "Path 7735",
    className: "cls-4",
    d: "M261.482,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,261.482,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7736",
    "data-name": "Path 7736",
    className: "cls-4",
    d: "M272.232,44.557a4.916,4.916,0,0,0,4.913-4.912,4.86,4.86,0,0,0-.678-2.45,58.5,58.5,0,0,0-8.322-.249,4.906,4.906,0,0,0,4.087,7.611Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7737",
    "data-name": "Path 7737",
    className: "cls-4",
    d: "M251.669,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,251.669,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7738",
    "data-name": "Path 7738",
    className: "cls-4",
    d: "M261.482,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,261.482,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7739",
    "data-name": "Path 7739",
    className: "cls-4",
    d: "M261.482,247.491a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,261.482,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7740",
    "data-name": "Path 7740",
    className: "cls-4",
    d: "M261.482,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,261.482,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7741",
    "data-name": "Path 7741",
    className: "cls-4",
    d: "M302.609,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,302.609,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7742",
    "data-name": "Path 7742",
    className: "cls-4",
    d: "M261.482,284.372a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,261.482,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7743",
    "data-name": "Path 7743",
    className: "cls-4",
    d: "M251.669,192.182a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,251.669,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7744",
    "data-name": "Path 7744",
    className: "cls-4",
    d: "M251.669,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,251.669,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7745",
    "data-name": "Path 7745",
    className: "cls-4",
    d: "M282.045,136.759a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,282.045,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7746",
    "data-name": "Path 7746",
    className: "cls-4",
    d: "M272.232,265.932a4.913,4.913,0,1,0-4.912-4.912A4.913,4.913,0,0,0,272.232,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7747",
    "data-name": "Path 7747",
    className: "cls-4",
    d: "M272.232,302.813a4.912,4.912,0,1,0-4.912-4.913A4.913,4.913,0,0,0,272.232,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7748",
    "data-name": "Path 7748",
    className: "cls-4",
    d: "M272.232,118.318a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,272.232,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7749",
    "data-name": "Path 7749",
    className: "cls-4",
    d: "M302.609,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,302.609,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    "data-name": "Path 7750",
    className: "cls-4",
    d: "M272.232,81.438a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,272.232,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7751",
    "data-name": "Path 7751",
    className: "cls-4",
    d: "M302.609,63a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,302.609,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7752",
    "data-name": "Path 7752",
    className: "cls-4",
    d: "M292.8,44.557a4.866,4.866,0,0,0,3.636-1.637,58.117,58.117,0,0,0-8.526-3.41c0,.045-.011.09-.011.136A4.892,4.892,0,0,0,292.8,44.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7753",
    "data-name": "Path 7753",
    className: "cls-4",
    d: "M272.232,229.051a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,272.232,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7754",
    "data-name": "Path 7754",
    className: "cls-4",
    d: "M282.045,247.491a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,282.045,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7755",
    "data-name": "Path 7755",
    className: "cls-4",
    d: "M282.045,284.372a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,282.045,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7756",
    "data-name": "Path 7756",
    className: "cls-4",
    d: "M282.045,210.622a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,282.045,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7757",
    "data-name": "Path 7757",
    className: "cls-4",
    d: "M272.232,192.182a4.913,4.913,0,1,0-4.912-4.912A4.913,4.913,0,0,0,272.232,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7758",
    "data-name": "Path 7758",
    className: "cls-4",
    d: "M282.045,173.628a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,282.045,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7759",
    "data-name": "Path 7759",
    className: "cls-4",
    d: "M272.232,155.2a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,272.232,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7760",
    "data-name": "Path 7760",
    className: "cls-4",
    d: "M160.326,63a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,160.326,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7761",
    "data-name": "Path 7761",
    className: "cls-4",
    d: "M78.084,284.372a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,78.084,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7762",
    "data-name": "Path 7762",
    className: "cls-4",
    d: "M68.271,265.932a4.913,4.913,0,1,0-4.912-4.912A4.913,4.913,0,0,0,68.271,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7763",
    "data-name": "Path 7763",
    className: "cls-4",
    d: "M78.084,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,78.084,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7764",
    "data-name": "Path 7764",
    className: "cls-4",
    d: "M78.084,247.491a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,78.084,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7765",
    "data-name": "Path 7765",
    className: "cls-4",
    d: "M68.271,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,68.271,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7766",
    "data-name": "Path 7766",
    className: "cls-4",
    d: "M68.271,192.182a4.913,4.913,0,1,0-4.912-4.912A4.913,4.913,0,0,0,68.271,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7767",
    "data-name": "Path 7767",
    className: "cls-4",
    d: "M57.532,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,57.532,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7768",
    "data-name": "Path 7768",
    className: "cls-4",
    d: "M57.532,284.372a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,57.532,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7769",
    "data-name": "Path 7769",
    className: "cls-4",
    d: "M62.433,58.085a5.177,5.177,0,0,0-.181-1.265A56.978,56.978,0,0,0,57.532,63,4.906,4.906,0,0,0,62.433,58.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7770",
    "data-name": "Path 7770",
    className: "cls-4",
    d: "M57.532,247.491a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,57.532,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7771",
    "data-name": "Path 7771",
    className: "cls-4",
    d: "M68.271,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,68.271,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7772",
    "data-name": "Path 7772",
    className: "cls-4",
    d: "M78.084,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,78.084,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7773",
    "data-name": "Path 7773",
    className: "cls-4",
    d: "M78.084,63a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,78.084,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7774",
    "data-name": "Path 7774",
    className: "cls-4",
    d: "M78.084,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,78.084,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7775",
    "data-name": "Path 7775",
    className: "cls-4",
    d: "M78.084,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,78.084,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7776",
    "data-name": "Path 7776",
    className: "cls-4",
    d: "M68.271,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,68.271,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7777",
    "data-name": "Path 7777",
    className: "cls-4",
    d: "M68.271,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,68.271,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7778",
    "data-name": "Path 7778",
    className: "cls-4",
    d: "M98.647,247.491a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,98.647,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7779",
    "data-name": "Path 7779",
    className: "cls-4",
    d: "M98.647,284.372a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,98.647,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7780",
    "data-name": "Path 7780",
    className: "cls-4",
    d: "M88.834,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,88.834,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7781",
    "data-name": "Path 7781",
    className: "cls-4",
    d: "M88.834,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,88.834,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7782",
    "data-name": "Path 7782",
    className: "cls-4",
    d: "M88.834,302.813a4.912,4.912,0,1,0-4.912-4.913A4.913,4.913,0,0,0,88.834,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7783",
    "data-name": "Path 7783",
    className: "cls-4",
    d: "M88.834,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,88.834,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7784",
    "data-name": "Path 7784",
    className: "cls-4",
    d: "M88.834,192.182a4.913,4.913,0,1,0-4.912-4.912A4.913,4.913,0,0,0,88.834,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7785",
    "data-name": "Path 7785",
    className: "cls-4",
    d: "M98.647,63a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,98.647,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7786",
    "data-name": "Path 7786",
    className: "cls-4",
    d: "M98.647,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,98.647,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7787",
    "data-name": "Path 7787",
    className: "cls-4",
    d: "M88.834,44.557a4.916,4.916,0,0,0,4.912-4.912,4.707,4.707,0,0,0-.226-1.389,58.2,58.2,0,0,0-9.327,2.891A4.878,4.878,0,0,0,88.834,44.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7788",
    "data-name": "Path 7788",
    className: "cls-4",
    d: "M98.647,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,98.647,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7789",
    "data-name": "Path 7789",
    className: "cls-4",
    d: "M98.647,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,98.647,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7790",
    "data-name": "Path 7790",
    className: "cls-4",
    d: "M98.647,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,98.647,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7791",
    "data-name": "Path 7791",
    className: "cls-4",
    d: "M88.834,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,88.834,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7792",
    "data-name": "Path 7792",
    className: "cls-4",
    d: "M179.952,348.309a4.907,4.907,0,0,0-4.077,2.168,58.3,58.3,0,0,0,8.718,1.219A4.882,4.882,0,0,0,179.952,348.309Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7793",
    "data-name": "Path 7793",
    className: "cls-4",
    d: "M190.7,339.682a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,190.7,339.682Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7794",
    "data-name": "Path 7794",
    className: "cls-4",
    d: "M200.515,348.309a4.923,4.923,0,0,0-4.528,3,59.557,59.557,0,0,0,7.938-1.614A4.856,4.856,0,0,0,200.515,348.309Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7795",
    "data-name": "Path 7795",
    className: "cls-4",
    d: "M52.62,261.019a4.888,4.888,0,0,0-4.607-4.878,58.421,58.421,0,0,0,.226,9.734A4.9,4.9,0,0,0,52.62,261.019Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7796",
    "data-name": "Path 7796",
    className: "cls-4",
    d: "M98.647,311.428a4.916,4.916,0,0,0-4.912,4.912c0,.034.011.056.011.09a58.472,58.472,0,0,0,9.6,1.242,4.762,4.762,0,0,0,.2-1.332A4.9,4.9,0,0,0,98.647,311.428Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7797",
    "data-name": "Path 7797",
    className: "cls-4",
    d: "M119.21,311.428a4.916,4.916,0,0,0-4.912,4.912,4.729,4.729,0,0,0,.079.8,57.7,57.7,0,0,0,9.509-2.191A4.878,4.878,0,0,0,119.21,311.428Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7798",
    "data-name": "Path 7798",
    className: "cls-4",
    d: "M144.674,316.34a4.912,4.912,0,0,0-9.824,0c0,.09.023.181.023.271.485,1.118.993,2.224,1.535,3.3a4.9,4.9,0,0,0,8.266-3.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7799",
    "data-name": "Path 7799",
    className: "cls-4",
    d: "M47.719,192.182a4.913,4.913,0,1,0-4.912-4.912A4.913,4.913,0,0,0,47.719,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7800",
    "data-name": "Path 7800",
    className: "cls-4",
    d: "M324.561,237.9a4.831,4.831,0,0,0-1.4-.226,4.912,4.912,0,1,0,3.873,7.893A56.07,56.07,0,0,0,324.561,237.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7801",
    "data-name": "Path 7801",
    className: "cls-4",
    d: "M318.26,279.459a4.916,4.916,0,0,0,4.912,4.913h.056a56.588,56.588,0,0,0,3.219-8.537,4.892,4.892,0,0,0-8.187,3.624Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7802",
    "data-name": "Path 7802",
    className: "cls-4",
    d: "M338.823,224.139a4.912,4.912,0,1,0-6.832,4.517,57.592,57.592,0,0,0,6.8-4.246A1.893,1.893,0,0,0,338.823,224.139Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7803",
    "data-name": "Path 7803",
    className: "cls-4",
    d: "M282.045,311.428a4.916,4.916,0,0,0-4.912,4.912,4.312,4.312,0,0,0,.113,1.016,58.321,58.321,0,0,0,9.61-1.931A4.9,4.9,0,0,0,282.045,311.428Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7804",
    "data-name": "Path 7804",
    className: "cls-4",
    d: "M316.995,294.637a4.9,4.9,0,1,0-6.5,7.25c.406-.384.824-.768,1.219-1.175A57.765,57.765,0,0,0,316.995,294.637Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7805",
    "data-name": "Path 7805",
    className: "cls-4",
    d: "M261.482,311.428a4.9,4.9,0,0,0-4.878,4.618,57.9,57.9,0,0,0,9.61,1.525,4.834,4.834,0,0,0-4.732-6.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7806",
    "data-name": "Path 7806",
    className: "cls-4",
    d: "M233.364,330.444a4.877,4.877,0,0,0-6.5,6.764A57.45,57.45,0,0,0,233.364,330.444Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7807",
    "data-name": "Path 7807",
    className: "cls-4",
    d: "M152.33,339.32a4.9,4.9,0,1,0-6.493-5.973A57.068,57.068,0,0,0,152.33,339.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7808",
    "data-name": "Path 7808",
    className: "cls-4",
    d: "M57.532,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,57.532,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7809",
    "data-name": "Path 7809",
    className: "cls-4",
    d: "M57.532,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,57.532,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7810",
    "data-name": "Path 7810",
    className: "cls-4",
    d: "M52.619,76.525a4.847,4.847,0,0,0-.757-2.586,58.415,58.415,0,0,0-2.247,7.114A4.906,4.906,0,0,0,52.619,76.525Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7811",
    "data-name": "Path 7811",
    className: "cls-4",
    d: "M19.161,201.645c.655,1.434,1.378,2.834,2.146,4.189,0-.045.011-.09.011-.136A4.9,4.9,0,0,0,19.161,201.645Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7812",
    "data-name": "Path 7812",
    className: "cls-4",
    d: "M47.719,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,47.719,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7813",
    "data-name": "Path 7813",
    className: "cls-4",
    d: "M49.571,108.867a59.61,59.61,0,0,0,2.258,7.193,4.852,4.852,0,0,0,.79-2.653A4.909,4.909,0,0,0,49.571,108.867Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7814",
    "data-name": "Path 7814",
    className: "cls-4",
    d: "M57.532,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,57.532,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7815",
    "data-name": "Path 7815",
    className: "cls-4",
    d: "M47.719,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,47.719,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7816",
    "data-name": "Path 7816",
    className: "cls-4",
    d: "M36.969,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,36.969,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7817",
    "data-name": "Path 7817",
    className: "cls-4",
    d: "M36.969,136.747a4.9,4.9,0,0,0,3.523-8.322,56.988,56.988,0,0,0-7.7,5.94A4.854,4.854,0,0,0,36.969,136.747Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7818",
    "data-name": "Path 7818",
    className: "cls-4",
    d: "M36.969,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,36.969,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7819",
    "data-name": "Path 7819",
    className: "cls-4",
    d: "M16.405,173.628a4.912,4.912,0,1,0,0-9.824,4.316,4.316,0,0,0-1.016.113A58.235,58.235,0,0,0,14,172.962,4.717,4.717,0,0,0,16.405,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7820",
    "data-name": "Path 7820",
    className: "cls-4",
    d: "M27.155,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,27.155,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7821",
    "data-name": "Path 7821",
    className: "cls-4",
    d: "M27.155,192.182a4.913,4.913,0,1,0-4.912-4.912A4.913,4.913,0,0,0,27.155,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7822",
    "data-name": "Path 7822",
    className: "cls-4",
    d: "M170.139,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,170.139,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7823",
    "data-name": "Path 7823",
    className: "cls-4",
    d: "M179.952,284.372a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,179.952,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7824",
    "data-name": "Path 7824",
    className: "cls-4",
    d: "M179.952,247.491a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,179.952,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7825",
    "data-name": "Path 7825",
    className: "cls-4",
    d: "M179.952,321.252a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,179.952,321.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7826",
    "data-name": "Path 7826",
    className: "cls-4",
    d: "M170.139,339.682a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,170.139,339.682Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7827",
    "data-name": "Path 7827",
    className: "cls-4",
    d: "M150.513,302.813A4.912,4.912,0,1,0,145.6,297.9,4.913,4.913,0,0,0,150.513,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7828",
    "data-name": "Path 7828",
    className: "cls-4",
    d: "M160.326,321.252a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,160.326,321.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7829",
    "data-name": "Path 7829",
    className: "cls-4",
    d: "M179.952,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,179.952,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7830",
    "data-name": "Path 7830",
    className: "cls-4",
    d: "M170.139,302.813a4.912,4.912,0,1,0-4.912-4.913A4.913,4.913,0,0,0,170.139,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7831",
    "data-name": "Path 7831",
    className: "cls-4",
    d: "M170.139,7.688a4.921,4.921,0,0,0,4.607-3.252,57.764,57.764,0,0,0-7.464,2.326A5.012,5.012,0,0,0,170.139,7.688Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7832",
    "data-name": "Path 7832",
    className: "cls-4",
    d: "M179.952,26.128a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,179.952,26.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7833",
    "data-name": "Path 7833",
    className: "cls-4",
    d: "M129.949,256.118a4.912,4.912,0,1,0,4.912,4.912A4.916,4.916,0,0,0,129.949,256.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7834",
    "data-name": "Path 7834",
    className: "cls-4",
    d: "M129.949,292.988a4.912,4.912,0,1,0,4.912,4.912A4.916,4.916,0,0,0,129.949,292.988Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7835",
    "data-name": "Path 7835",
    className: "cls-4",
    d: "M179.952,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,179.952,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7836",
    "data-name": "Path 7836",
    className: "cls-4",
    d: "M179.952,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,179.952,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7837",
    "data-name": "Path 7837",
    className: "cls-4",
    d: "M179.952,63a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,179.952,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7838",
    "data-name": "Path 7838",
    className: "cls-4",
    d: "M179.952,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,179.952,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7839",
    "data-name": "Path 7839",
    className: "cls-4",
    d: "M170.139,265.932a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,170.139,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7840",
    "data-name": "Path 7840",
    className: "cls-4",
    d: "M170.139,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,170.139,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7841",
    "data-name": "Path 7841",
    className: "cls-4",
    d: "M170.139,44.568a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,170.139,44.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7842",
    "data-name": "Path 7842",
    className: "cls-4",
    d: "M170.139,192.182a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,170.139,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7843",
    "data-name": "Path 7843",
    className: "cls-4",
    d: "M170.139,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,170.139,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7844",
    "data-name": "Path 7844",
    className: "cls-4",
    d: "M170.139,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,170.139,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7845",
    "data-name": "Path 7845",
    className: "cls-4",
    d: "M160.326,26.128a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,160.326,26.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7846",
    "data-name": "Path 7846",
    className: "cls-4",
    d: "M150.513,229.051a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,150.513,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7847",
    "data-name": "Path 7847",
    className: "cls-4",
    d: "M150.513,192.182a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,150.513,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7848",
    "data-name": "Path 7848",
    className: "cls-4",
    d: "M150.513,155.2a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,150.513,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7849",
    "data-name": "Path 7849",
    className: "cls-4",
    d: "M150.513,44.568a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,150.513,44.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7850",
    "data-name": "Path 7850",
    className: "cls-4",
    d: "M150.513,265.932a4.913,4.913,0,1,0-4.912-4.912A4.912,4.912,0,0,0,150.513,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7851",
    "data-name": "Path 7851",
    className: "cls-4",
    d: "M150.513,81.438a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,150.513,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7852",
    "data-name": "Path 7852",
    className: "cls-4",
    d: "M150.513,118.318a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,150.513,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7853",
    "data-name": "Path 7853",
    className: "cls-4",
    d: "M109.4,192.182a4.913,4.913,0,1,0-4.913-4.912A4.913,4.913,0,0,0,109.4,192.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7854",
    "data-name": "Path 7854",
    className: "cls-4",
    d: "M109.4,229.051a4.912,4.912,0,1,0-4.913-4.912A4.912,4.912,0,0,0,109.4,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7855",
    "data-name": "Path 7855",
    className: "cls-4",
    d: "M119.21,284.372a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,119.21,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7856",
    "data-name": "Path 7856",
    className: "cls-4",
    d: "M88.834,265.932a4.913,4.913,0,1,0-4.912-4.912A4.913,4.913,0,0,0,88.834,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7857",
    "data-name": "Path 7857",
    className: "cls-4",
    d: "M109.4,155.2a4.912,4.912,0,1,0-4.913-4.912A4.912,4.912,0,0,0,109.4,155.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7858",
    "data-name": "Path 7858",
    className: "cls-4",
    d: "M119.21,247.491a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,119.21,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7859",
    "data-name": "Path 7859",
    className: "cls-4",
    d: "M129.949,118.318a4.912,4.912,0,1,0-4.912-4.912A4.916,4.916,0,0,0,129.949,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7860",
    "data-name": "Path 7860",
    className: "cls-4",
    d: "M109.4,81.438a4.912,4.912,0,1,0-4.913-4.912A4.913,4.913,0,0,0,109.4,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7861",
    "data-name": "Path 7861",
    className: "cls-4",
    d: "M109.4,118.318a4.912,4.912,0,1,0-4.913-4.912A4.912,4.912,0,0,0,109.4,118.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7862",
    "data-name": "Path 7862",
    className: "cls-4",
    d: "M119.21,63a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,119.21,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7863",
    "data-name": "Path 7863",
    className: "cls-4",
    d: "M119.21,99.878a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,119.21,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7864",
    "data-name": "Path 7864",
    className: "cls-4",
    d: "M109.4,44.557a4.88,4.88,0,0,0,4.348-7.159,58.225,58.225,0,0,0-8.413-.5,4.915,4.915,0,0,0,4.065,7.656Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7865",
    "data-name": "Path 7865",
    className: "cls-4",
    d: "M119.21,210.622a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,119.21,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7866",
    "data-name": "Path 7866",
    className: "cls-4",
    d: "M119.21,136.759a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,119.21,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7867",
    "data-name": "Path 7867",
    className: "cls-4",
    d: "M119.21,173.628a4.912,4.912,0,1,0-4.912-4.912A4.913,4.913,0,0,0,119.21,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7868",
    "data-name": "Path 7868",
    className: "cls-4",
    d: "M109.4,265.932a4.913,4.913,0,1,0-4.913-4.912A4.913,4.913,0,0,0,109.4,265.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7869",
    "data-name": "Path 7869",
    className: "cls-4",
    d: "M139.774,284.372a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,139.774,284.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7870",
    "data-name": "Path 7870",
    className: "cls-4",
    d: "M139.774,247.491a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,139.774,247.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7871",
    "data-name": "Path 7871",
    className: "cls-4",
    d: "M129.949,229.051a4.912,4.912,0,1,0-4.912-4.912A4.916,4.916,0,0,0,129.949,229.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7872",
    "data-name": "Path 7872",
    className: "cls-4",
    d: "M139.774,210.622a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,139.774,210.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7873",
    "data-name": "Path 7873",
    className: "cls-4",
    d: "M109.4,302.813a4.912,4.912,0,1,0-4.913-4.913A4.913,4.913,0,0,0,109.4,302.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7874",
    "data-name": "Path 7874",
    className: "cls-4",
    d: "M129.949,192.17a4.912,4.912,0,1,0-4.912-4.912A4.916,4.916,0,0,0,129.949,192.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7875",
    "data-name": "Path 7875",
    className: "cls-4",
    d: "M129.949,155.188a4.912,4.912,0,1,0-4.912-4.913A4.916,4.916,0,0,0,129.949,155.188Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7876",
    "data-name": "Path 7876",
    className: "cls-4",
    d: "M129.949,81.438a4.912,4.912,0,1,0-4.912-4.912A4.916,4.916,0,0,0,129.949,81.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7877",
    "data-name": "Path 7877",
    className: "cls-4",
    d: "M144.347,22.943c-.689.79-1.355,1.592-2,2.428A4.917,4.917,0,0,0,144.347,22.943Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7878",
    "data-name": "Path 7878",
    className: "cls-4",
    d: "M129.949,44.557a4.916,4.916,0,0,0,4.913-4.912,5.19,5.19,0,0,0-.158-1.186c-.678,1.615-1.3,3.264-1.83,4.957a57.409,57.409,0,0,0-7.78-3.331A4.888,4.888,0,0,0,129.949,44.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7879",
    "data-name": "Path 7879",
    className: "cls-4",
    d: "M139.774,63a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,139.774,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7880",
    "data-name": "Path 7880",
    className: "cls-4",
    d: "M139.774,173.628a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,139.774,173.628Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7881",
    "data-name": "Path 7881",
    className: "cls-4",
    d: "M139.774,99.878a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,139.774,99.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7882",
    "data-name": "Path 7882",
    className: "cls-4",
    d: "M139.774,136.759a4.912,4.912,0,1,0-4.912-4.912A4.912,4.912,0,0,0,139.774,136.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7883",
    "data-name": "Path 7883",
    className: "cls-5",
    d: "M363,176.189a58.17,58.17,0,0,0-40.607-55.457,58.171,58.171,0,0,0-78.425-78.425,58.172,58.172,0,0,0-110.913,0A58.171,58.171,0,0,0,54.63,120.732a58.167,58.167,0,0,0-.023,110.913,58.171,58.171,0,0,0,78.425,78.425,58.171,58.171,0,0,0,110.913,0,58.171,58.171,0,0,0,78.425-78.425A58.159,58.159,0,0,0,363,176.189Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/cloud-2.26ce7e11b4647866283006b01b0aa890.svg";
export { ForwardRef as ReactComponent };